import { FC, ReactNode } from 'react';
import { classNames } from 'utils/classNames';
import styles from './FormSectionLabels.module.css';
import { Typography } from 'antd';

interface IFormSectionLabelsProps {
	label: ReactNode;
	extra?: ReactNode;
	isRequired?: boolean;
}

export const FormSectionLabels: FC<IFormSectionLabelsProps> = ({ label, extra, isRequired = false }) => {
	return (
		<div>
			<Typography.Title
				level={4}
				className={classNames({
					[styles.required]: isRequired,
				})}
				style={{ marginBottom: 0 }}
			>
				{label}
			</Typography.Title>

			{extra && <Typography.Text type='secondary'>{extra}</Typography.Text>}
		</div>
	);
};
